module.exports = __webpack_public_path__ + "img/big_1_40.4797bc76.png";